
// Function to show and hide the popup
    function togglePopup() {
        $(".popup-content").toggle();
    }
// Function to show and hide the popup
  function togglePopup1() {
      $(".omnisend-form-640f55a4653128bbaea27da1-container").toggle();
  }


 $(".show-more-button-main a").click(function(){
    $(".omnisend-form-640f55a4653128bbaea27da1-content").append("<button class='close-omni' onclick='togglePopup1()'>X</button>");
  });


